export const authQueryKeys = {
  token: ['token'],
} as const;
